export default {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  API_LOCAL_NETWORK: import.meta.env.VITE_API_LOCAL_NETWORK === "1",
  IS_DEV: import.meta.env.DEV,
  RE_CAPTCHA_SITE_KEY: import.meta.env.VITE_RE_CAPTCHA_SITE_KEY,
  UMAMI_WEBSITE_ID: import.meta.env.VITE_UMAMI_WEBSITE_ID,
  MAPBOX_ACCESS_TOKEN: import.meta.env.VITE_MAPBOX_ACCESS_TOKEN,
  MAPTILER_ACCESS_TOKEN: import.meta.env.VITE_MAPTILER_ACCESS_TOKEN,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  STRIPE_CUSTOMER_PORTAL_URL: import.meta.env.VITE_STRIPE_CUSTOMER_PORTAL_URL,
  FB_APP_ID: import.meta.env.VITE_FB_APP_ID,
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
};
